import { addDays, differenceInCalendarDays } from "date-fns";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { Button } from "../../../../../components/button";
import React from "react";

function BillingWarning() {
  let session = useSelector((state) => state.session);

  if (session.account.billingPlan === "free") {
    let daysRemaining = differenceInCalendarDays(
      addDays(new Date(session.account.when), 30),
      new Date()
    );

    if (daysRemaining > 0) {
      return (
        <p className={"flex flex-col gap-3 "} style={{ maxWidth: 500 }}>
          <div>Your free trial will end soon.</div>
          <div
            className={
              "h-10 w-full bg-green-600 text-white rounded flex items-center justify-center relative"
            }
          >
            <div
              className={"w-full h-full absolute top-0 right-0"}
              style={{
                width: 100 * (1 - daysRemaining / 30) + "%",
                backgroundColor: "rgba(255,255,255,20%)",
              }}
            ></div>
            {daysRemaining} remaining days
          </div>{" "}
          <div>
            If you want to upgrade to a paid plan, please contact us{" "}
            <Link to={"/settings/help"} className={"underline"}>
              here
            </Link>
          </div>
        </p>
      );
    } else {
      return (
        <p className={"bg-red-200 rounded p-3 flex flex-col gap-3 "}>
          <div className={"font-bold"}>Your free trial has ended.</div>
          <div>
            If you want to continue, please upgrade by contacting us
            <Link to={"/settings/help"} className={"underline"}>
              here
            </Link>
            .
          </div>
        </p>
      );
    }
  } else {
    return (
      <div>
        <p className={"flex flex-col gap-3"}>
          <div>
            <Trans
              i18nKey="settings.billing.current_plan"
              values={{
                billingPlan: session.account.billingPlan,
              }}
              components={{
                s: <strong />,
              }}
            />
          </div>
          <div>
            Current usage:
            <ul className={"ml-3"}>
              <li>
                {session.stats.documentsLast30days} documents created last 30
                days
              </li>
              <li>{session.stats.contactsTotal} contacts in the directory</li>
            </ul>
          </div>
          <div>
            If you want to upgrade, please contact us
            <Link to={"/settings/help"} className={"underline"}>
              here
            </Link>
            .
          </div>
        </p>
      </div>
    );
  }
}

export function SettingsBillingPage() {
  return (
    <div className={"flex flex-col gap-3 p-3"}>
      {" "}
      <div className={"flex"}>
        <h2 className={"font-bold py-2 flex items-center flex-grow"}>
          Billing
        </h2>
      </div>
      <BillingWarning />
    </div>
  );
}
